export default __webpack_public_path__ + "static/media/trade_hk_09.51eec891.png";